// extracted by mini-css-extract-plugin
export default {"MovieCard":"MovieCardVertical_style_MovieCard__4nDQm","over_lay":"MovieCardVertical_style_over_lay__pOFgg"};